import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import classNames from "classnames";
import { forwardRef, type ReactNode } from "react";

export interface SpaceGroupViewWrapperProps {
  children?: ReactNode;
  className?: string;
  isCollapsed?: boolean;
  isDragging?: boolean;
  onCollapseToggle?: () => void;
}

export const SpaceGroupViewWrapper = forwardRef<
  HTMLButtonElement,
  SpaceGroupViewWrapperProps
>(
  (
    {
      isCollapsed = false,
      children,
      onCollapseToggle,
      isDragging,
      className,
      ...rest
    },
    ref,
  ) => {
    const { currentCommunityMember } = usePunditUserContext();

    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          "text-c-sidebar hover:text-c-sidebar hover:bg-c-sidebar-hover focus-visible:text-c-sidebar focus-visible:bg-c-sidebar-hover focus-visible:outline-secondary mb-1 flex w-full select-none items-center justify-between rounded-md px-4 py-1.5 text-sm font-semibold transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
          {
            "cursor-grab":
              !isDragging && isCommunityAdmin(currentCommunityMember),
            "cursor-grabbing": isDragging,
          },
          className,
        )}
        data-testid="space-group"
        onClick={onCollapseToggle}
        aria-expanded={!isCollapsed}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

SpaceGroupViewWrapper.displayName = "SpaceGroupViewWrapper";
